import React, { useContext, useEffect, useState } from 'react';
// import CargoNameAutoComplete from '../../common/CargoAutoComplete';
import { CargoTypesContext } from '../HiresPage';
import BasicSelector from '../../TcIndex/Basic/BasicSelector';
import { MenuItem } from 'material-ui';
import { isEqual } from 'lodash';

function HireCargo({
    cargo, cargoType, countIndex, changeFieldsMultiple, 
}) {
    const cargoTypes = useContext(CargoTypesContext);
    const [cargoTypeValue, setCargoTypeValue] = useState(cargoType);
    // ---- that is commented because according to task, cargo value must be hidden
    // ---- ---- i will keep that here, because i am sure the task will later be changed
    // const changeCargo = useCallback((value) => {
    //     const toChange = [{ index: countIndex, field: 'cargo', value }];

    //     if (value.parent && value.parent.red && value.parent.red._id) {
    //         toChange.push({
    //             index: countIndex, field: 'cargoType', value: value.parent.red,
    //         });
    //     }

    //     changeFieldsMultiple(toChange);
    // }, [countIndex, changeFieldsMultiple]);

    useEffect(() => {
        setCargoTypeValue(cargoType);
    }, [cargoType]);

    const selectCargoType = (value) => {
        changeFieldsMultiple([
            { index: countIndex, field: 'cargo', value: undefined },
            { index: countIndex, field: 'cargoTypeId', value: cargoTypes.find(c => c._id === value) },
        ]);
    };

    return (
        <React.Fragment>
            {/* <CargoNameAutoComplete 
                name={`cargo_${countIndex}`}
                item={cargo || {}}
                _preventFirstSearch
                updateItem={changeCargo}
                style={{ fontSize: '9px' }}
                floatingLabelStyle={{ display: 'none' }}
                // underlineStyle={{ display: 'none' }}
                hintText={null}
                menuStyle={{ width: '300px' }}
                popoverProps={{
                    style: { width: '300px' },
                }}
                inputStyle={{ fontSize: '9px', width: '77px', height: '24px' }}
                textFieldStyle={{ width: '77px', height: '24px' }}
            /> */}
            <BasicSelector 
                value={cargoType ? cargoType._id : ''}
                dataList={cargoTypes || []}
                onChange={(e, _i, value) => selectCargoType(value)}
                iconStyle={{ display: 'none' }}
                underlineStyle={{ display: 'none' }}
                style={{ fontSize: '9px' }}
                labelStyle={{ padding: 0, top: 'unset' }}
                customRender={(cargoTypes || [])
                    .map(item => (<MenuItem 
                        key={item._id}
                        value={item._id}
                        primaryText={item.name}
                    />))
                }
            />
        </React.Fragment>
    );
}

export default React.memo(HireCargo, (prev, next) => 
    isEqual(prev.cargoType, next.cargoType) &&
    prev.countIndex === next.countIndex &&
    isEqual(prev.changeFieldsMultiple, next.changeFieldsMultiple));



// WEBPACK FOOTER //
// ./app/components/Hires/rowData/HireCargo.jsx